/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const AccordionBody = ({ className, children }) => {

  return (
    <div className={className}>{children}</div>
  );
};

AccordionBody.displayName = 'AccordionDetails';

AccordionBody.propTypes = {
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Class atttribute for component.
   */
  className: PropTypes.string
};

export { AccordionBody };